import type {
  CargoCounterSnapshot,
  CargoLifecycleProjection,
} from '../services/cargoLifecycle/cargoLifecycleProjectionTypes';
import {
  computeCargoTransportDisplay,
  computeCargoTransportDisplayFromProjection,
  type CargoTransportDisplay,
} from './cargoDerivedTransportStatus';
import type { CargoAllocationCore } from './applicationCargoAllocationStats';

export function snapshotFromProjection(projection: CargoLifecycleProjection): CargoCounterSnapshot {
  const transport = computeCargoTransportDisplayFromProjection(projection);
  return {
    inRoutes: projection.inRoutesActive,
    inTransit: projection.inTransitActive,
    available: projection.available,
    delivered: projection.deliveredTotal,
    transportLabel: transport.label,
    byRoute: projection.byRoute.map((row) => ({
      routeId: row.routeId,
      amount: row.active,
      active: row.active,
      delivered: row.delivered,
      routeStatus: row.routeStatus,
    })),
  };
}

export function emptyCargoCounterSnapshot(quantity = 0): CargoCounterSnapshot {
  return {
    inRoutes: 0,
    inTransit: 0,
    available: Math.max(0, quantity),
    delivered: 0,
    transportLabel: 'Не распределён',
    byRoute: [],
  };
}

/** @deprecated CARGO-L3 — use snapshotFromProjection when projection UI is enabled. */
export function snapshotFromLegacyAllocation(
  quantity: number,
  core: CargoAllocationCore | undefined,
  routeStatusById: Map<number, string>
): CargoCounterSnapshot {
  const inRoutesTotal = core?.inRoutesTotal ?? 0;
  const byRoute = core?.byRoute ?? [];
  const transport: CargoTransportDisplay = computeCargoTransportDisplay(quantity, byRoute, routeStatusById);
  return {
    inRoutes: inRoutesTotal,
    inTransit: transport.inTransit,
    available: transport.available,
    delivered: 0,
    transportLabel: transport.label,
    byRoute: byRoute.map((row) => ({
      routeId: row.routeId,
      amount: row.amount,
      active: row.amount,
      delivered: 0,
      routeStatus: routeStatusById.get(row.routeId) ?? null,
    })),
  };
}

export function resolveCargoCounterSnapshot(params: {
  cargoId: number;
  quantity: number;
  projectionIndex: Map<number, CargoLifecycleProjection>;
  legacyIndex: Map<number, CargoAllocationCore>;
  routeStatusById: Map<number, string>;
  useProjection: boolean;
}): CargoCounterSnapshot {
  if (params.useProjection) {
    const projection = params.projectionIndex.get(params.cargoId);
    if (projection) return snapshotFromProjection(projection);
    return emptyCargoCounterSnapshot(params.quantity);
  }
  return snapshotFromLegacyAllocation(
    params.quantity,
    params.legacyIndex.get(params.cargoId),
    params.routeStatusById
  );
}
